import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import FinancialTableRow from '../FinancialTableRow';
import styles from './FinancialTableFooter.style';

const FinancialTableFooter = ({
  name,
  amount,
  currency,
  returnsIncluded,
  isPerCap,
  className: classNameProp,
  ...other
}) => {
  const classNames = clsx(styles.root, classNameProp);

  return (
    <FinancialTableRow
      name={name}
      amount={amount}
      currency={currency}
      className={classNames}
      isFooter
      returnsIncluded={returnsIncluded}
      isPerCap={isPerCap}
      {...other}
    />
  );
};

FinancialTableFooter.propTypes = {
  name: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string,
  className: PropTypes.string,
  returnsIncluded: PropTypes.number,
  isPerCap: PropTypes.bool,
};

FinancialTableFooter.defaultProps = {
  className: '',
  currency: '',
  returnsIncluded: null,
  isPerCap: false,
};

export default FinancialTableFooter;
